import { createContext, useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import usePrevious from '@/hooks/usePrevious'

const Context = createContext({})
const { Provider, Consumer } = Context

const ContextComponent = ({
  children,
}) => {
  const [layout, setLayout] = useState('dark')
  const [isNavOpen, setNavOpen] = useState(false)
  const [isCollectionNavOpen, setCollectionNavOpen] = useState(false)
  const [isHomepage, setHomepage] = useState(false)
  const [isProductPage, setProductPage] = useState(false)
  const [isFullscreenMode, setFullscreenMode] = useState(false)
  const [headerHeight, setHeaderHeight] = useState(0)
  const [isBackButtonVisible, setBackButtonVisible] = useState(false)
  const [isModalCartVisible, setModalCartVisible] = useState(false)
  const [enableArchiveToScroll, setEnableArchiveToScroll] = useState(false)
  const [enableSingleToScroll, setEnableSingleToScroll] = useState(false)
  const [backButtonLink, setBackButtonLink] = useState('')
  const [headerRef, setHeaderRef] = useState({})
  const [cookieRef, setCookieRef] = useState({})

  const { content, pathname, hash } = useSelector((state) => ({
    content: state.page,
    pathname: state.router.location.pathname,
    hash: state.router.location.hash,
  }))
  const prevPathname = usePrevious(pathname)

  useEffect(() => {
    if (prevPathname?.includes('/collection/')) setEnableArchiveToScroll(true)
    if (prevPathname?.includes('/product/')) setEnableSingleToScroll(true)
  }, [pathname])

  const getImageUrl = (index, size = 'full', slug = null, type = 'pages') => {
    let page = null
    if (slug === null) {
      const { current, currentType } = content
      page = currentType === 'pages' ? content.pages : content.posts
      slug = current
    } else {
      page = type === 'pages' ? content.pages : content.posts
    }
    if (`${slug}` in page) {
      page = page[slug].media_post
      if ((page[index] !== undefined) && (page[index].sizes !== undefined)) {
        if (page[index].sizes[size] !== undefined) {
          return `${page[index].source_url}/${page[index].sizes[size].file}`
        }
        return `${page[index].source_url}/${page[index].sizes.full.file}`
      }
    }
    return ''
  }

  const getImageTitle = (index, slug = null, type = 'pages') => {
    let page = null
    if (slug === null) {
      const { current, currentType } = content
      page = currentType === 'pages' ? content.pages : content.posts
      slug = current
    } else {
      page = type === 'pages' ? content.pages : content.posts
    }
    if (`${slug}` in page) {
      page = page[slug].media_post
      if ((page[index] !== undefined) && (page[index].title !== undefined)) {
        return page[index].title
      }
    }
    return ''
  }

  useEffect(() => {
    if (prevPathname && prevPathname !== pathname) {
      setBackButtonVisible(false)
      setBackButtonLink('')
    }
  }, [pathname])

  useEffect(() => {
    setModalCartVisible(hash.includes('cart'))
  }, [hash])

  return (
    <Provider value={{
      getImageUrl,
      getImageTitle,
      layout,
      setLayout,
      isNavOpen,
      setNavOpen,
      isFullscreenMode,
      setFullscreenMode,
      isCollectionNavOpen,
      setCollectionNavOpen,
      isBackButtonVisible,
      setBackButtonVisible,
      backButtonLink,
      setBackButtonLink,
      setHomepage,
      isHomepage,
      setProductPage,
      isProductPage,
      headerHeight,
      setHeaderHeight,
      setHeaderRef,
      headerRef,
      setCookieRef,
      cookieRef,
      isModalCartVisible,
      setModalCartVisible,
      enableArchiveToScroll,
      setEnableArchiveToScroll,
      enableSingleToScroll,
      setEnableSingleToScroll,
    }}
    >
      { children }
    </Provider>
  )
}

export {
  Context,
  Consumer,
}

export default ContextComponent
